// extracted by mini-css-extract-plugin
module.exports = {"cls1":"index-Container-module--cls1--3DSmp","long":"index-Container-module--long--3ZGYc"};